var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    _vm._b(
      {
        ref: "dialog",
        attrs: {
          width: "600",
          scrollable: "",
          persistent: "",
          eager: ""
        },
        on: {
          keydown: function keydown($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            return _vm.$emit("close")
          },
          "click:outside": function clickOutside($event) {
            return _vm.$emit("close")
          }
        },
        model: {
          value: _vm.modal,
          callback: function callback($$v) {
            _vm.modal = $$v
          },
          expression: "modal"
        }
      },
      "v-dialog",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "v-card",
        {
          staticClass: "app-card card-borderless"
        },
        [
          _vm.isToolbarSlotActive
            ? _c(
                "gg-toolbar",
                {
                  on: {
                    close: function close($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._t("toolbar")],
                2
              )
            : _vm._e(),
          _vm.isTitleSlotActive
            ? _c("v-card-title", [_vm._t("title")], 2)
            : _vm._e(),
          _vm.isBodySlotActive
            ? _c(
                "v-card-text",
                {
                  staticClass: "pt-2 pb-3"
                },
                [_vm._t("body")],
                2
              )
            : _vm._e(),
          _vm.isActionsSlotActive
            ? _c(
                "v-card-actions",
                {
                  staticClass: "justify-content-end pb-4"
                },
                [_vm._t("actions")],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }